import { API } from "../../../helpers/API/amplifyApi";

/**
 * Fetch employees for the employeesList report with server-side filters.
 * Avoids dumping the full Redux employee list into the report grid.
 *
 * @param {{ statuses?: string[], employeeId?: string|null }} opts
 *   - statuses: employeeStatus values (IN). Empty/omitted → all statuses.
 *   - employeeId: optional narrow via employeeId-index.
 */
export async function fetchEmployeesForReport({
  statuses = [],
  employeeId = null,
  employeeTeam = null,
} = {}) {
  const queryStringParameters = {};

  if (employeeId) {
    queryStringParameters.filterKey = "employeeId";
    queryStringParameters.filterValue = String(employeeId);
  }

  if (employeeTeam) {
    queryStringParameters.employeeTeam = String(employeeTeam);
  }

  if (Array.isArray(statuses) && statuses.length > 0) {
    // Multi-status: new API (`employeeStatus` / `filterValues` with IN).
    // Single status also sets legacy filterKey/filterValue for older lambdas.
    const joined = statuses.join(",");
    queryStringParameters.employeeStatus = joined;
    queryStringParameters.filterValues = joined;
    if (!employeeId && statuses.length === 1) {
      queryStringParameters.filterKey = "employeeStatus";
      queryStringParameters.filterValue = statuses[0];
    }
  } else if (!employeeId) {
    // Explicit "all statuses" so the API does not rely on a silent default.
    queryStringParameters.employeeStatus = "all";
  }

  return API.get("employees", "/employees", { queryStringParameters });
}
